import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-forward",
  "use": "arrow-forward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-forward\"><path d=\"M8 14v1a7 7 0 116-10.607V1.5c-.002-.002 0-.5.5-.5s.5.5.5.5V6h-4.5s-.5 0-.5-.5c0-.467.438-.495.495-.5h2.703A6 6 0 108 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol